import { createAsyncThunk } from "@reduxjs/toolkit";
import { onboardingApi } from "../../../api/onboardingApi";
import { RootState } from "../../../store";
import { onboardingSelectors } from "../../onboarding/onboarding.selectors";
import { ERROR_CODES } from "../constants";
import { onfidoInitialState, setOnfidoState } from "../reducer";
import { selectOnfidoState } from "../selectors";

export const getNextOnfidoPhase = createAsyncThunk<void>(
  "onfido/GET_NEXT_ONFIDO_PHASE",
  async (_, thunkApi) => {
    const { dispatch, rejectWithValue, getState } = thunkApi;
    const state = getState() as RootState;
    const onfidoState = selectOnfidoState(state);
    const { currentPhaseIndex, phases } = onfidoState;
    const onboardingStepData = onboardingSelectors.data(state);
    const processId = onboardingStepData?.processId;
    const step = onboardingStepData?.step;
    try {
      if (phases?.[currentPhaseIndex + 1]) {
        dispatch(
          setOnfidoState({
            currentPhaseIndex: currentPhaseIndex + 1,
          }),
        );
      } else {
        if (!processId) {
          throw Error("Process id not found");
        }
        if (!step) {
          throw Error("Step not defined");
        }
        dispatch(setOnfidoState(onfidoInitialState));
        await dispatch(
          onboardingApi.endpoints.next.initiate({
            data: {
              processId,
              step,
            },
            values: {},
          }),
        );
      }
    } catch (err) {
      return rejectWithValue(ERROR_CODES.NEXT_PHASE_GENERIC_ERROR);
    }
  },
);
